/**
 * @file ScrollToTop.tsx
 * @description Component that scrolls the window to the top on route changes.
 * This component is used in conjunction with react-router-dom to ensure
 * that new pages are always displayed from the beginning after navigation.
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
